import * as ExcelJS from 'exceljs'

import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import { Helper } from "@/mixin/helper";
import moment from 'moment'
moment.locale('id')

export const Export = {
  mixins: [Helper],
  methods: {
    async exportToExcel (fields, data, filename, title, subtitle) {
      const options = {
        filename: filename + '.xlsx'
      }

      const workbook = new ExcelJS.Workbook(options)
      const worksheet = workbook.addWorksheet(filename)

      worksheet.columns = fields;
      worksheet.getCell('A1').value = title;
      worksheet.mergeCells('A1', this.numToSSColumn(fields.length) + '1');
      worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell('A1').font = {
        size: 20,
        bold: true
      };
      worksheet.getCell('A2').value = subtitle;
      worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.mergeCells('A2', this.numToSSColumn(fields.length) + '2');
      worksheet.getCell('A2').font = {
        size: 12
      };
      worksheet.getRow(4).values = fields.map(item => item.label);
      worksheet.getRow(4).font = {
        bold: true
      };
      worksheet.getRow(4).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      
      for (let index = 0; index < data.length; index++) {
        worksheet.addRow(data[index])
        worksheet.getRow((index + 1) + 4).alignment = { vertical: 'middle', wrapText: true };
      }

      const base64 = Buffer.from(await workbook.xlsx.writeBuffer()).toString(
        'base64'
      )

      // Download File
      const a = document.createElement('a') // Create <a>
      a.href = 'data:application/xlsx;base64,' + base64 // Image Base64 Goes here
      a.download = `${filename}.xlsx` // File name Here
      a.click()
    },

    async exportToExcelWithFooter (fields, data, filename, title, subtitle) {
      const options = {
        filename: filename + '.xlsx'
      }

      const workbook = new ExcelJS.Workbook(options)
      const worksheet = workbook.addWorksheet(filename)

      worksheet.columns = fields;
      worksheet.getCell('A1').value = title;
      worksheet.mergeCells('A1', this.numToSSColumn(fields.length) + '1');
      worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell('A1').font = {
        size: 20,
        bold: true
      };
      worksheet.getCell('A2').value = subtitle;
      worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.mergeCells('A2', this.numToSSColumn(fields.length) + '2');
      worksheet.getCell('A2').font = {
        size: 12
      };
      worksheet.getRow(4).values = fields.map(item => item.label);
      worksheet.getRow(4).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      worksheet.getRow(4).font = {
        bold: true
      };
      
      for (let index = 0; index < data.length; index++) {
        worksheet.addRow(data[index])
        worksheet.getRow((index + 1) + 4).alignment = { vertical: 'middle', wrapText: true };
      }

      worksheet.getRow(data.length + 4).font = {
        bold: true
      };

      const base64 = Buffer.from(await workbook.xlsx.writeBuffer()).toString(
        'base64'
      )

      // Download File
      const a = document.createElement('a') // Create <a>
      a.href = 'data:application/xlsx;base64,' + base64 // Image Base64 Goes here
      a.download = `${filename}.xlsx` // File name Here
      a.click()
    },

    exportTableToPdf (fields, data, filename, repeat, title, subtitle) {
      const doc = new jsPDF('l');
      var totalPagesExp = '{total_pages_count_string}';

      var repeatSection = {};
      if(repeat !== null) {
        repeatSection = {
          horizontalPageBreak: true,
          horizontalPageBreakRepeat: repeat
        }
      }
      var self = this;
      doc.text(150, 20, title, 'center');
      doc.setFontSize(10);
      doc.text(150, 27, subtitle, 'center');
      doc.setFontSize(14);
      autoTable(doc, {
        columns: fields,
        body: data,
        startY: 30,
        ...repeatSection,
        didDrawPage: function (page) {
          // Footer
          var str = 'Halaman ' + doc.internal.getNumberOfPages()
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === 'function') {
            str = str + '/' + totalPagesExp
          }
          doc.setFontSize(10)

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, 260, pageHeight - 10)

          doc.text('Pengguna\t: ' + self.getUserName() + "\nTanggal\t   : " + moment().format("DD MMM YYYY - HH:mm"), page.settings.margin.left, pageHeight - 10)
        }
      });

      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      
      doc.save(`${filename}.pdf`)
    },

    exportTableToPdfWithFooter (fields, data, filename, repeat, title, subtitle, footer) {
      const doc = new jsPDF('l');
      var totalPagesExp = '{total_pages_count_string}';

      var repeatSection = {};
      var self = this;
      doc.text(150, 20, title, 'center');
      doc.setFontSize(10);
      doc.text(150, 27, subtitle, 'center');
      doc.setFontSize(14);
      autoTable(doc, {
        columns: fields,
        foot: [footer],
        body: data,
        startY: 30,
        ...repeatSection,
        didDrawPage: function (page) {
          // Footer
          var str = 'Halaman ' + doc.internal.getNumberOfPages()
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === 'function') {
            str = str + '/' + totalPagesExp
          }
          doc.setFontSize(10)

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, 260, pageHeight - 10)

          doc.text('Pengguna\t: ' + self.getUserName() + "\nTanggal\t   : " + moment().format("DD MMM YYYY - HH:mm"), page.settings.margin.left, pageHeight - 10)
        }
      });

      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      
      doc.save(`${filename}.pdf`)
    },

    numToSSColumn(num){
      var s = '', t;
    
      while (num > 0) {
        t = (num - 1) % 26;
        s = String.fromCharCode(65 + t) + s;
        num = (num - t)/26 | 0;
      }
      return s || undefined;
    }
  }
}
